import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import data from '../../data';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF',
    padding: '50px 0',
  },
  footerLogo: {
    width: '100%',
    maxWidth: 228,
    height: 'auto',
    marginBottom: 20,
  },
  copyright: {
    fontWeight: 'lighter',
    fontSize: 14,
  },
  menuTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    textTransform: 'uppercase',
    marginBottom: 20,
  },
  menuList: {
    margin: 0,
    padding: 0,
    '& > li': {
      paddingLeft: 0,
      paddingBottom: 3,
      paddingTop: 3,
    },
  },
  menuLink: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    color: '#FFFFFF',
    textDecoration: 'none',
    fontWeight: 'lighter',
  },
}));

const Footer = ({ lang }) => {
  const classes = useStyles();
  return (
    <Box className={classes.footer}>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <img src="./assets/footer-logo.png" className={classes.footerLogo} alt="Qlik Footer Logo" />
            <Typography variant="body1" className={classes.copyright}>{`© 1993-2021 QlikTech International AB, ${lang === 'jp' ? data.jp.footer.copyright : data.en.footer.copyright}`}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4}>
                <Typography variant="h3" className={classes.menuTitle}>
                  {lang === 'jp' ? data.jp.footer.title1 : data.en.footer.title1}
                </Typography>
                <List className={classes.menuList}>
                  <ListItem>
                    <a href="https://www.qlik.com/us/company" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link1 : data.en.footer.column1link1}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/company/press-room" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link2 : data.en.footer.column1link2}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/trust" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link3 : data.en.footer.column1link3}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/trust/accessibility" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link4 : data.en.footer.column1link4}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/trust/privacy" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link5 : data.en.footer.column1link5}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/company/careers" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link6 : data.en.footer.column1link6}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/contact" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link7 : data.en.footer.column1link7}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/try-or-buy/buy-now" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column1link8 : data.en.footer.column1link8}
                    </a>
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Typography variant="h3" className={classes.menuTitle}>
                  {lang === 'jp' ? data.jp.footer.title2 : data.en.footer.title2}
                </Typography>
                <List className={classes.menuList}>
                  <ListItem>
                    <a href="https://www.qlik.com/us/resource-library" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link1 : data.en.footer.column2link1}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/partners" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link2 : data.en.footer.column2link2}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/trial/qlik-free-trials" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link3 : data.en.footer.column2link3}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/compare" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link4 : data.en.footer.column2link4}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/learn/glossary" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link5 : data.en.footer.column2link5}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/services/training" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link6 : data.en.footer.column2link6}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/services/support" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column2link7 : data.en.footer.column2link7}
                    </a>
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Typography variant="h3" className={classes.menuTitle}>
                  {lang === 'jp' ? data.jp.footer.title3 : data.en.footer.title3}
                </Typography>
                <List className={classes.menuList}>
                  <ListItem>
                    <a href="https://www.qlik.com/us/legal/legal-policies" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column3link1 : data.en.footer.column3link1}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/legal/trademarks" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column3link2 : data.en.footer.column3link2}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/legal/terms-of-use" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column3link3 : data.en.footer.column3link3}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/legal/legal-agreements" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column3link4 : data.en.footer.column3link4}
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="https://www.qlik.com/us/legal/product-terms" className={classes.menuLink}>
                      {lang === 'jp' ? data.jp.footer.column3link5 : data.en.footer.column3link5}
                    </a>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

Footer.propTypes = {
  lang: PropTypes.string,
};

Footer.defaultProps = {
  lang: 'en',
};

export default Footer;
